<template>
  <div class="paper-download-button" v-if="show">
    <a @click="handleClick" target="_blank" :href="url" no-work-wechat>下载高清试卷</a>
    <span class="tips">有答案解析</span>
  </div>
</template>
<script>
import zhanqun from "../apis/zhanqun";
import MixinSite from "@/mixins/site";
import MixinZhanQun from "@/mixins/zhanqun";

export default {
  mixins: [MixinSite, MixinZhanQun],
  data() {
    return {
      url: "",
      title: ""
    };
  },
  created() {
    this.title = document.title.substring(0, document.title.indexOf('_')).trim()
    this.url = this.getNewUrl()
  },
  mounted() {
    this.trackEvent("show_pcsitedetail_article_downloadpapers", {
      visit_channel: this.currentSiteInfo.domain,
    });
  },
  computed:{
    show() {
      const title = document.title;
      return (
        title.search(/试卷|真题|模拟题|试题/) >= 0 ||
        window.location.href.search("test") >= 0
      );
    }
  },
  methods: {
    getUrl() {
      return (
        `${this.currentSiteInfo.index}/tiku/?` +
        zhanqun.buildQueryString({
          keyword: this.title,
        })
      );
    },
    getNewUrl() {
      return this.getHomePageUrl({keyword:this.title, ...this.urlParams})
    },
    handleClick() {
      this.trackEvent("click_pcsitedetail_article_downloadpapers", {
        visit_channel: this.currentSiteInfo.domain,
      });
    },
    trackEvent(name, attributes) {
      console.log(name, attributes);
      window.sensors && window.sensors.track(name, attributes);
    },
  },
};
</script>
<style scoped lang="scss">
.paper-download-button {
  margin: 20px auto 20px auto;
  text-align: center;
  a {
    position: relative;
    display: inline-block;
    text-decoration: none;
    border-width: 1px;
    border-style: solid;
    border-radius: 20px;
    @include main-color();
    padding: 8px 40px;
    font-size: 16px;
  }
  .tips {
    position: relative;
    display: inline-block;
    width: 68px;
    height: 19px;
    border-radius: 8px 8px 8px 2px;
    right: 35px;
    bottom: 20px;
    background: #ff3a3a;
    color: #fff;
    font-size: 12px;
    line-height: 19px;
  }
}
</style>
